module.exports = __webpack_public_path__ + "img/upsell-autocheck.710f63fb.svg";